function date(dateObj) {
  if (dateObj) {
    const month = dateObj.getMonth() + 1 > 9 ? dateObj.getMonth() + 1 : `0${dateObj.getMonth() + 1}`;
    const day = dateObj.getDate() > 9 ? dateObj.getDate() : `0${dateObj.getDate()}`;

    return `${dateObj.getFullYear()}/${month}/${day}`;
  }

  return '';
}

export default date;



// WEBPACK FOOTER //
// ./src/filters/date.js